module.exports = __webpack_public_path__ + "static/media/genericBankLogo.51f08bbb.svg";